import axios from '../utils/axios';

export default function getAllRecruiters (adminId, params) {
    return axios.get(`/admin/${adminId}/get-all-recruiters`, { params });
}